import React from "react";
import { Typography, Paper, Box } from "@material-ui/core";
import Moment from "react-moment";
import MapMarkerIcon from "mdi-react/MapMarkerIcon";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
  ort: {
    position: "relative",
    top: -8
  }
}));

const StTermin = ({ item }) => {
  const classes = useStyles();

  if (!item) {
    return null;
  }

  return (
    <>
      <Paper>
        <Box p={2} mb={2}>
          <Typography variant="caption">
            <Moment format={"DD.MM.YYYY"}>
              {item.veranstaltungsdatum.value}
            </Moment>
            {Boolean(item.uhrzeit.value) && " - " + item.uhrzeit.value + " Uhr"}
          </Typography>
          <Typography variant="h6">{item.titel.value}</Typography>
          <Typography variant="caption">
            <MapMarkerIcon />{" "}
            <span className={classes.ort}>{item.ort.value}</span>
          </Typography>
        </Box>
      </Paper>
    </>
  );
};

export default StTermin;
